import React from "react";
import "./css/SearchInterested.scss";
import SearchInterestedForm from "./SearchInterestedForm";

function SearchInterested({ all }) {
  return (
    <div id="SearchInterested" className="wrap_search_company">
      <div className="search_txt">
        <p className="page_title">
          알고싶은 기업·경쟁기업의 기술등급 알아보기
        </p>
        <p className="second_title">종합·정량·정성평가</p>
        <p className="semi_title">
          <span>기술역량 등급</span> 및 <span>등록특허 등급</span> 제공
        </p>
      </div>
      <SearchInterestedForm all={all} />
    </div>
  );
}

export default SearchInterested;
